import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useGoogleMap } from '@react-google-maps/api';

const CustomMapControl = ({ position, children }) => {
  const map = useGoogleMap();
  const controlRef = useRef(null);
  const controlDivRef = useRef(document.createElement('div'));

  useEffect(() => {
    if (map && position !== undefined) {
      // Only try to access controls when map is available
      if (!controlRef.current) {
        const controlDiv = controlDivRef.current;
        controlDiv.className = 'custom-map-control';
        controlDiv.style.margin = '10px';
        
        // Make sure map.controls exists before accessing it
        if (map.controls) {
          const controlPosition = position;
          map.controls[controlPosition].push(controlDiv);
          controlRef.current = controlDiv;
        }
      }

      // Clean up function to remove control when unmounted
      return () => {
        if (controlRef.current && map.controls && map.controls[position]) {
          const index = map.controls[position].indexOf(controlRef.current);
          if (index !== -1) {
            map.controls[position].removeAt(index);
            controlRef.current = null;
          }
        }
      };
    }
  }, [map, position]);

  if (!map || !controlRef.current) {
    return null;
  }

  return createPortal(children, controlRef.current);
};

export default CustomMapControl;